<div class="modal-header">
  <h5 class="modal-title ">¡Pago procesado correctamente!</h5>
</div>
<div class="modal-body p-4">
  <div class="text-center">
    <i style="font-size: 40px;" class="fa text-primary fa-shopping-basket mb-2"></i>
    <h6 style="padding: 5px;">
      Tu compra se realizó con éxito.
      ¡Prepárate para recibir tus productos en breve!
    </h6>
  </div>
</div>
<div class="modal-footer">
  <button type="button" name="button" class="btn btn-primary mr-2" (click)="modal.close({products: true })">Ver productos</button>
  <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="modal.close()">Mis pedidos
  </button>
</div>
